import React from 'react';
import { connect } from 'react-redux'
import { CircularProgress, Dialog, DialogContent } from '@material-ui/core';

const ActivityLoader = ({ isLoaderVisible }) => {
  if (isLoaderVisible)
    return (
      <Dialog open={isLoaderVisible}
        BackdropProps={{ style: { backgroundColor: 'rgba(0,0,0,0.1)' } }}>
        <DialogContent style={{ padding: 0 }}>
          <CircularProgress style={{ position: 'fixed', top: '45%', left: '45%', color: '#33cccc' }} />
        </DialogContent>
      </Dialog>
    )
  else return (<div />)
}

const mapStateToProps = ({ loader: { isLoaderVisible } }) => ({
  isLoaderVisible
})

export default connect(mapStateToProps)(ActivityLoader)